<template>
  <div class="goodswrap">
    <div class="head">
      <div class="title">参展商品</div>
      <div @click="change" class="tab">
        <img
          v-if="state"
          src="https://img.zai-art.com/zaiart/saas/image/md/2c5d139d7aef4be9a06cc33ba22940ea.png"
          alt=""
        />
        <img
          v-else
          src="https://img.zai-art.com/zaiart/saas/image/md/59aadeaaf35df69cb63ab418cdfd9dfc.png"
          alt=""
        />
      </div>
    </div>

    <div class="list">
      <template v-for="(item, index) in data">
        <Item :state="state" :key="index" :data="item"></Item>
      </template>
    </div>
  </div>
</template>
<script>
import { getShopGoodsList } from '@/api/index';
import Item from './item';
export default {
  components: {
    Item,
  },
  props: ['data'],
  data() {
    return {
      state: false,
    };
  },
  created() {},
  methods: {
    change() {
      this.state = !this.state;
    },
  },
};
</script>
<style lang="less" scoped>
.goodswrap {
  .head {
    padding: 20px 20px 0 20px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    position: sticky;
    top: 0;
    .title {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 22px;
      margin-bottom: 20px;
    }
    .tab img {
      display: block;
      width: 22px;
      height: 22px;
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
</style>
